import CustomViewOptionCustomSection from "csi/middleware/customView/options/CustomViewOptionCustomSection";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../../csi/middleware/customView/CustomViewDialogStore";
import SizeChartDataSheetCustomViewOptionsStore from "./SizeChartDataSheetCustomViewOptionsStore";
import SizeChartDataSheetOptions from "./SizeChartDataSheetOptions";

const SizeChartDataSheetViewOptions: FunctionComponent = observer(function SizeChartDataSheetViewOptions() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		toggleCollapsedViewSpecificOptions,
		viewSpecificOptionsCollapse,
	} = optionsStore as SizeChartDataSheetCustomViewOptionsStore;

	return (
		<CustomViewOptionCustomSection
			collapsed={viewSpecificOptionsCollapse}
			dataCsiAutomation="CustomViewSizeChartOptions"
			onCollapse={toggleCollapsedViewSpecificOptions}
			titleRes="CustomViewSizeChartOptions"
		>
			<SizeChartDataSheetOptions />
		</CustomViewOptionCustomSection>
	);
});

export default SizeChartDataSheetViewOptions;